export default __webpack_public_path__ + "b8c7821e69d3b1a3486658a581fe0d36.jpg";